import { useEffect } from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
  createBrowserRouter,
} from 'react-router-dom';
import { init, reactRouterV6BrowserTracingIntegration, wrapCreateBrowserRouterV6 } from '@sentry/react';

export const sentry = () =>
  init({
    dsn: process.env.NX_SENTRY_DSN_FRONTEND,
    environment: process.env.NX_ENVIRONMENT,
    integrations: [
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
  });

export const sentryRouter = wrapCreateBrowserRouterV6(createBrowserRouter);
